export type SnackbarPayload = { message: string; success: boolean; duration?: number };

class SnackbarService {
	private payload: SnackbarPayload | null = null;
	private subscribers: Array<(p: SnackbarPayload | null) => void> = [];

	show(payload: SnackbarPayload) {
		this.payload = payload;
		this.notify();
	}

	hide() {
		this.payload = null;
		this.notify();
	}

	subscribe(cb: (p: SnackbarPayload | null) => void) {
		this.subscribers.push(cb);
		return () => {
			this.subscribers = this.subscribers.filter(s => s !== cb);
		};
	}

	private notify() {
		this.subscribers.forEach(cb => cb(this.payload));
	}
}

export const snackbarService = new SnackbarService();
